import { faCheck, faClone } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

type Props = Readonly<{
  value: string;
  className?: string;
}>;

export function Copy({ value, className }: Props): JSX.Element {
  const [isCopied, setIsCopied] = useState(false);

  async function copyTextToClipboard(text: string) {
    await navigator.clipboard.writeText(text);
  }

  const handleCopyClick = () => {
    copyTextToClipboard(value)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <button
      className="h-5 w-5 ml-auto block"
      value={value}
      onClick={handleCopyClick}
    >
      {isCopied ? (
        <FontAwesomeIcon
          className={`h-5 w-5 text-green-500 ${className}`}
          icon={faCheck}
        />
      ) : (
        <FontAwesomeIcon
          className={`h-5 w-5 text-gray-500 dark:text-gray-400 ${className}`}
          icon={faClone}
        />
      )}
    </button>
  );
}
